import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import Reveal from "@/components/motion/Reveal";

const CtaBand = () => {
  const { t } = useLanguage();
  const waLink = `https://wa.me/${t.common.whatsappNumber}?text=${encodeURIComponent(t.whatsapp.message)}`;

  return (
    <section data-testid="cta-band" className="relative overflow-hidden bg-brand">
      <div className="absolute inset-0 bg-blueprint-fine opacity-40" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
          <div className="max-w-2xl">
            <Reveal>
              <h2 className="font-display font-black uppercase tracking-tight leading-[0.92] text-4xl sm:text-5xl lg:text-6xl text-ink">
                {t.ctaBand.title}
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-5 text-base leading-relaxed text-ink/75 max-w-xl">{t.ctaBand.text}</p>
            </Reveal>
          </div>
          <Reveal delay={0.15} className="flex flex-col sm:flex-row gap-3 shrink-0">
            <Link
              to="/devis"
              data-testid="cta-band-quote-button"
              className="group flex items-center justify-center gap-3 bg-ink px-8 py-4 font-display text-lg font-bold uppercase tracking-[0.12em] text-cream transition-colors hover:bg-surface"
            >
              {t.ctaBand.button}
              <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
            </Link>
            <a
              href={waLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-band-whatsapp-button"
              className="flex items-center justify-center gap-3 border-2 border-ink px-8 py-4 font-display text-lg font-bold uppercase tracking-[0.12em] text-ink transition-colors hover:bg-ink hover:text-cream"
            >
              {t.ctaBand.whatsapp}
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default CtaBand;
